import {BrowserModule} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';

import {CoreModule} from '@app/core';
import {SharedModule} from '@app/shared';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';

import {ContentLayoutComponent} from './layouts/content-layout/content-layout.component';
import {NavComponent} from './layouts/nav/nav.component';
import {FooterComponent} from './layouts/footer/footer.component';

import {AuthModule} from './modules/auth/auth.module';
import {AuthLayoutComponent} from './layouts/auth-layout/auth-layout.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HeaderComponent} from './layouts/header/header.component';
import {LangComponent} from './layouts/header/modals/lang/lang.component';
import {CurrencyComponent} from './layouts/header/modals/currency/currency.component';
import {ManagerComponent} from './layouts/manager/manager.component';
//import { RoomDetailsComponent } from './checkprice/availibility/components/room/Modals/room-details/room-details.component';
import {WindowRefService} from './core/window-ref.service';
import {FormsModule} from '@angular/forms';
import {SentryErrorHandler} from './core/sentry-error-handler';

@NgModule({
    declarations: [
        AppComponent,
        ContentLayoutComponent,
        NavComponent,
        FooterComponent,
        AuthLayoutComponent,
        HeaderComponent,
        LangComponent,
        CurrencyComponent,
        ManagerComponent,
        //    RoomDetailsComponent
    ],
    imports: [
        // angular
        BrowserModule,

        // 3rd party
        AuthModule,

        // core & shared
        CoreModule,
        SharedModule,
        FormsModule,

        // app
        AppRoutingModule,

        BrowserAnimationsModule
    ],
    providers: [
        {provide: ErrorHandler, useClass: SentryErrorHandler}
    ],
    bootstrap: [AppComponent],
    entryComponents: [LangComponent, CurrencyComponent]
})
export class AppModule {

    constructor(private winRef: WindowRefService) {
        let langNav = this.winRef.appConfigSite.defaultlangue;//this.winRef.nativeWindow.navigator.language;
        let valueMapping: string = this.winRef.mappedLang(langNav);
        this.winRef.localeInitializer(valueMapping, langNav);
    }

}
